import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import BugReportRoundedIcon from '@mui/icons-material/BugReportRounded';
import { useCallback } from 'react';
import { createRequestPlayerDebugInfoOutbound } from '../../../api/outbound/commonOutbounds';
import { MenuItemContainer } from '../../../components/menuItemContainer';
import { useSocketSend } from '../../../context/webSocket/webSocketContext';
export const PlayerRequestDebugInfoMenuItem = ({ playerIdName, closeMenu }) => {
    const socketSend = useSocketSend();
    const onClick = useCallback(() => {
        socketSend(createRequestPlayerDebugInfoOutbound(playerIdName.id));
    }, [socketSend, playerIdName.id]);
    return (_jsx(MenuItemContainer, { label: 'Request Debug Info', svgIconComponent: BugReportRoundedIcon, onClick: onClick, closeMenu: closeMenu }));
};
